import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-27f78b44"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-main-wrapper"
};
const _hoisted_2 = {
  class: "layer"
};
const _hoisted_3 = {
  style: {
    "margin": "0 auto"
  },
  class: "teacher-wrapper"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "teacher_head"
}, "教学名师", -1));

const _hoisted_5 = {
  class: "teacher-list"
};
const _hoisted_6 = {
  key: 1,
  class: "no-data"
};
const _hoisted_7 = {
  class: "more"
};
const _hoisted_8 = ["href"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TeacherCard = _resolveComponent("TeacherCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_ArrowRight = _resolveComponent("ArrowRight");

  const _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [$data.teacherList && $data.teacherList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.teacherList, teacherData => {
    return _openBlock(), _createBlock(_component_TeacherCard, {
      teacherData: teacherData,
      key: teacherData.teacher_id,
      menu: $props.menu,
      class: "teacher-card"
    }, null, 8, ["teacherData", "menu"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_Empty, {
    type: "people"
  })]))])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("a", {
    href: `/teacherList.html?menuId=${$props.menu.menu_id}`
  }, [_hoisted_9, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })], 8, _hoisted_8)])]);
}